import { Button, Form, Input, Skeleton } from 'antd'
import React, { Fragment } from 'react'


interface IProps {
	closeModal: (result: string) => void;
	initialValue?: string;
	editMode: boolean;
}

const SupplierEmailForm: React.FC<IProps> = ({ closeModal, initialValue, editMode }) => {

	const onFinish = async (values: any) => {
		closeModal(values.email);
	}

	return (
		<Fragment>
			<Skeleton loading={!initialValue && editMode}>
				<Form
					labelCol={{ span: 6 }}
					wrapperCol={{ span: 18 }}
					layout='horizontal'
					initialValues={{ email: initialValue }}
					onFinish={onFinish}
				>
					<Form.Item label='Email' name='email'
						rules={[{ required: true, message: 'Please input the email!' }]}
					>
						<Input autoComplete='off' />
					</Form.Item>
					<Form.Item style={{ float: 'right' }}>
						<Button type="primary" htmlType="submit">
							{editMode ? 'Save Changes' : 'Save Content'}
						</Button>
					</Form.Item>
				</Form>
			</Skeleton>
		</Fragment>
	)
}

export default SupplierEmailForm
